import React, { useMemo, useState } from 'react';
import { Platform, TouchableOpacity, View } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, InputStateToken, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import Typography from '../../typography/Typography';
import { addCommasToNumber } from '../utils';
import Icon from '../../icon/Icon';
import Divider from '../../divider/Divider';
import TextInput from '../../textInput/TextInput';
import * as Animatable from 'react-native-animatable';
const FlexiRepayScreen = ({ height, contactUsDetails, principalLoanAmount, preFilledAmount, goBackAction, navigateToSummaryScreenAction, trackPaymentSelectionAction, triggerAction }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [inputValue, setInputValue] = useState(preFilledAmount || 0);
    const [isLoading, setLoading] = useState(false);
    const [fullAmountSelected, setFullAmountSelected] = useState(false);
    const [partialAmountSelected, setPartialAmountSelected] = useState(preFilledAmount ? true : false);
    const [currentState, setCurrentState] = useState(InputStateToken.DEFAULT);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const handlePress = async () => {
        setLoading(true);
        await triggerAction({
            ...navigateToSummaryScreenAction,
            payload: {
                inputValue,
                ...navigateToSummaryScreenAction.payload
            }
        });
        setLoading(false);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Flexi repay', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const footerChild = useMemo(() => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 16, flex: 1, width: '100%', } },
            (inputValue > 0 && inputValue <= principalLoanAmount) && React.createElement(View, { style: { marginBottom: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: `Paying ₹${addCommasToNumber(inputValue)}`, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { marginHorizontal: 16 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, loading: isLoading, typeDLS: ButtonTypeDLS.PRIMARY, label: `Select payment method`, onPress: handlePress, isDisabled: inputValue === undefined || inputValue <= 0 || inputValue > principalLoanAmount }))));
    }, [inputValue]);
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 500 },
            React.createElement(View, null,
                React.createElement(View, { style: { paddingHorizontal: 16, paddingVertical: 12, backgroundColor: '#F9FAFB' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: `Outstanding amount` }),
                    React.createElement(View, { style: { marginTop: 6 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night, label: `₹ ${addCommasToNumber(principalLoanAmount)}` }))),
                React.createElement(View, { style: { marginVertical: 24, paddingHorizontal: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, label: `Select amount for repayment` })),
                React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: async () => {
                        if (!fullAmountSelected) {
                            setInputValue(principalLoanAmount);
                            if (trackPaymentSelectionAction) {
                                await triggerAction({
                                    ...trackPaymentSelectionAction,
                                    payload: {
                                        type: 'fullPay',
                                        ...trackPaymentSelectionAction.payload,
                                    }
                                });
                            }
                        }
                        setFullAmountSelected(!fullAmountSelected);
                        setPartialAmountSelected(false);
                    }, style: { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 16 } },
                    React.createElement(Icon, { name: fullAmountSelected ? IconTokens.RadioCircleFilled : IconTokens.RadioCircleNotFilled, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL }),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { typeDLS: fullAmountSelected ? TypographyTypeDLS.B0S : TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night, label: 'Pay full amount' }))),
                React.createElement(View, { style: { marginVertical: 24, marginHorizontal: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: async () => {
                        if (!partialAmountSelected && trackPaymentSelectionAction) {
                            await triggerAction({
                                ...trackPaymentSelectionAction,
                                payload: {
                                    type: 'partialPay',
                                    ...trackPaymentSelectionAction.payload,
                                }
                            });
                        }
                        setPartialAmountSelected(!partialAmountSelected);
                        setFullAmountSelected(false);
                        setInputValue(0);
                    }, style: { flexDirection: 'row', alignItems: 'center', paddingHorizontal: 16 } },
                    React.createElement(Icon, { name: partialAmountSelected ? IconTokens.RadioCircleFilled : IconTokens.RadioCircleNotFilled, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL }),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { typeDLS: partialAmountSelected ? TypographyTypeDLS.B0S : TypographyTypeDLS.B0R, color: ColorTokens.Grey_Night, label: 'Pay partial amount' }))),
                partialAmountSelected && React.createElement(View, { style: { marginTop: 24, marginLeft: 52, marginRight: 16 } },
                    React.createElement(TextInput, { title: "Enter amount", nonZeroStartingNumberPattern: true, onlyNumeric: true, 
                        //@ts-ignore
                        value: inputValue, state: currentState, showErrorOnFocus: true, onChangeText: (text) => {
                            if (text > principalLoanAmount) {
                                setCurrentState(InputStateToken.ERROR);
                            }
                            else
                                setCurrentState(InputStateToken.DEFAULT);
                            setInputValue(text);
                        }, triggerAction: triggerAction, caption: {
                            error: `${(currentState === InputStateToken.ERROR) ? `Maximum repayment amount is ₹${addCommasToNumber(principalLoanAmount)}` : ``}`
                        } })))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.White, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            showNeedHelp &&
                React.createElement(View, { style: { paddingBottom: 12, zIndex: 1 } },
                    React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })),
            footerChild) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default FlexiRepayScreen;
